<template>
  <div class="table-ellipsis">
    <el-table
      v-if="dataList.some((ele) => getFileType(ele.fileName))"
      :data="dataList"
      tooltip-effect="light"
      class="imgTable"
      :show-header="false"
      :cell-style="{ border: 'none', padding: '0 !important' }"
    >
      <el-table-column label="">
        <template slot-scope="scope">
          <span
            v-if="getFileType(scope.row.fileName)"
            style="
              display: inline-block;
              width: 52px;
              height: 52px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              :src="productpreshowurl(scope.row.hashCode, 8060)"
              @click="preview(scope.row)"
              alt=""
              :class="{ 'cusor-pointer': !sensitive }"
              style="max-width: 100%; max-height: 100%"
            />
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="dataList"
      tooltip-effect="light"
      :show-header="false"
      :cell-style="{ border: 'none', padding: '0 !important' }"
    >
      <el-table-column show-overflow-tooltip label="">
        <template slot-scope="scope">
          <span
            class="files"
            style="cursor: pointer"
            @click="downLoad(scope.row.url, scope.row.hashCode)"
            v-if="!getFileType(scope.row.fileName) && !sensitive"
            >{{ scope.row.fileName }}</span
          >
          <span v-else-if="!getFileType(scope.row.fileName) && sensitive">{{
            scope.row.fileName
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-image-viewer
      class="customer-follow-image-viewer"
      v-if="dialogVisible"
      :on-close="closeViewer"
      :url-list="imgList"
      :initialIndex="initialIndex"
    />
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { downloadFileFun } from '@/utils/common.js'
import { fileUrl } from '@/utils/config.js'
export default {
  components: {
    ElImageViewer,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    sensitive: {
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      imageUrl: '',
      imgName: '',
      imgList: [],
      initialIndex: 0,
      fileUrl,
    }
  },
  methods: {
    getFileType(val) {
      const ext = val ? val.substr(val.lastIndexOf('.') + 1, val.length) : true
      let arr = ['png', 'jpg', 'jpeg']
      const isExt = arr.includes(ext.toLowerCase())
      return isExt
    },
    getImgList(val) {
      const fileType = ['png', 'jpeg', 'jpg']
      this.imgList = []
      this.dataList.forEach((item) => {
        const name = item.fileName || ''
        const ext = name
        ? name.substr(
          name.lastIndexOf('.') + 1,
          name.length
          )
          : true
        if (ext && fileType.includes(ext.toLowerCase())) {
          this.imgList.push(`${fileUrl}/preview-static?code=${item.hashCode}`)
        }
      })
      this.imgList.forEach((item, index) => {
        if (item.includes(val.hashCode)) {
          this.initialIndex = index
        }
      })
    },
    productpreshowurl(hashCode, thn) {
      return `${fileUrl}/preview-static?code=${hashCode}&thn=S`
    },
    downLoad(url, hashCode) {
      return downloadFileFun(`${fileUrl}/download-static?code=${hashCode}`)
    },
    closeViewer() {
      this.dialogVisible = false
    },
    preview(val) {
      this.getImgList(val)
      this.dialogVisible = true
    },
  },
}
</script>
<style lang="scss">
.table-ellipsis {
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: #fff;
    height: 0;
  }
  .el-table {
    background: none;
    .el-table__row {
      background-color: transparent !important;
    }
    td {
      .cell {
        background-color: transparent !important;
      }
      background-color: transparent !important;
    }
  }
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    padding: 0 !important;
  }

  .imgTable {
    border-spacing: 0;
    .el-table__row {
      display: inline-block;
      .cell {
        display: inline-block;
      }
      span {
        margin-right: 5px;
        border: 1px solid #ddd;
      }
    }
  }
  .files {
    color: #066eb7;
    cursor: default;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
  }
  .files:hover {
    border-bottom: 1px solid;
  }
  .imgdialog {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .cusor-pointer {
    cursor: pointer;
  }
}
.customer-follow-image-viewer {
  z-index: 99999 !important;
}
</style>
